import { defineMessages } from 'react-intl'

export default defineMessages({
  confirmation: {
    id: 'components.Commons.ConfirmationTooltip.confirmation',
    defaultMessage: 'Are you sure ?',
  },
  yes: {
    id: 'components.Commons.ConfirmationTooltip.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'components.Commons.ConfirmationTooltip.no',
    defaultMessage: 'No',
  },
})
